import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { NetworkActionError } from '../errors/network.action.error';
import { DeleteActionState } from '../../../helpers/types';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class DeleteEntityActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = true;
  protected requiresTasksEnabled = false;

  private unremovableTypes: Array<number> = [
    Constants.ProtectedEntities.EPS.CUSTOM_GROUPS,
    Constants.Companies.TYPE_COMPANY_NETWORK,
    Constants.Companies.TYPE_COMPANIES_COLLECTION,
    Constants.ProtectedEntities.EPS.TYPE_EXCLUDED_FOLDER,
    Constants.ProtectedEntities.CONTAINERS.TYPE_COLLECTION,
    Constants.ProtectedEntities.CONTAINERS.TYPE_CUSTOM_GROUPS,
  ];

  private nonDeletableAwsIntegrationTypes: Array<number> = [
    Constants.ProtectedEntities.EPS.TYPE_AWS_GROUP,
    Constants.ProtectedEntities.EPS.TYPE_AWS_ACCOUNT,
    Constants.ProtectedEntities.EPS.TYPE_AWS_REGION,
    Constants.ProtectedEntities.EPS.TYPE_AWS_AZ,
    Constants.ProtectedEntities.EPS.TERMINATED_INSTANCES_GROUP,
  ];

  private nonDeleteableVMWareIntegrationTypes: Array<number> = [
    Constants.ProtectedEntities.EPS.VMWARE_COLLECTION,
    Constants.ProtectedEntities.EPS.VMWARE_CENTER,
    Constants.ProtectedEntities.EPS.VMWARE_DATACENTER,
    Constants.ProtectedEntities.EPS.VMWARE_FOLDER,
    Constants.ProtectedEntities.EPS.VMWARE_COMPUTE_RESOURCE,
    Constants.ProtectedEntities.EPS.VMWARE_CLUSTER_COMPUTE_RESOURCE,
    Constants.ProtectedEntities.EPS.VMWARE_RESOURCE_POOL,
    Constants.ProtectedEntities.EPS.VMWARE_VIRTUAL_APP,
    Constants.ProtectedEntities.EPS.VMWARE_HOST_SYSTEM,
    Constants.ProtectedEntities.EPS.VMWARE_VIRTUAL_MACHINE
  ];

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (this.unremovableTypes.includes(record.type)) {
      throw new NetworkActionError(
        'Selected targets cannot be deleted',
        DeleteActionState.DEFAULT_TARGETS_IN_SELECTED_ITEMS
      );
    }

    if (this.nonDeletableAwsIntegrationTypes.includes(record.type)) {
      throw new NetworkActionError('AWS non-deletable entities.', DeleteActionState.NON_DELETABLE_AWS_ENTITIES);
    }

    if (this.nonDeleteableVMWareIntegrationTypes.includes(record.type)) {
      throw new NetworkActionError('VMWare non-deletable entities.', DeleteActionState.NON_DELETABLE_VMWARE_ENTITIES);
    }

    if (record.readOnly) {
      throw new NetworkActionError(
        'Selected targets cannot be deleted',
        DeleteActionState.DEFAULT_TARGETS_IN_SELECTED_ITEMS
      );
    }

    if (record.type === Constants.Companies.TYPE_COMPANY) {
      throw new NetworkActionError('Company in deleted entities', DeleteActionState.COMPANY_IN_SELECTED_ITEMS);
    }

    if (record.type === Constants.ProtectedEntities.CONTAINERS.TYPE_CONTAINER) {
      throw new NetworkActionError('Container in selected items', DeleteActionState.CONTAINER_IN_SELECTED_ITEMS);
    }

    if (record.type === Constants.ProtectedEntities.CONTAINERS.TYPE_HOST) {
      throw new NetworkActionError(
        'Container host in deleted entities',
        DeleteActionState.CONTAINER_HOST_FOLDER_IN_SELECTED_ITEMS
      );
    }

    if (ProtectedEntitiesHelper.isAwsInstance(record) && !ProtectedEntitiesHelper.isPowerStateTerminated(record)) {
      throw new NetworkActionError('AWS non-deletable entities.', DeleteActionState.NON_DELETABLE_AWS_ENTITIES);
    }

    return true;
  }
}
